import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('tempEmailDB', {
  version: 1,
  key: 'email',
  // expireDuration: null,
})

export default dataDB
